import { GetDepartmentFragment } from '@/graphql/custom-types';
import {
  GetDepartmentDocument,
  GetDepartmentWeatherDocument,
  GetDepartmentTravelPlanDocument,
} from '@/graphql/generated-types';
import { apolloClient } from '@/utils/apollo';
import SentryGraphQLError from '@/utils/exceptions/SentryGraphQLError';

const getDepartment = async (id: string): Promise<GetDepartmentFragment> => {
  const response = await apolloClient.query({
    query: GetDepartmentDocument,
    variables: { id },
    errorPolicy: 'all',
  });

  if (response.data?.department) {
    return response.data.department;
  }

  throw new SentryGraphQLError('api.department.getDepartment', response);
};

const getDepartmentWeather = async (id: string): Promise<string> => {
  const response = await apolloClient.query({
    query: GetDepartmentWeatherDocument,
    variables: { id },
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
  });

  if (response.data.departmentWeather) {
    return response.data.departmentWeather;
  }

  throw new SentryGraphQLError('api.department.getDepartmentWeather', response);
};

const getDepartmentTravelPlan = async (id: string) => {
  const response = await apolloClient.query({
    query: GetDepartmentTravelPlanDocument,
    variables: { id },
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
  });

  if (response.data?.externalServices?.getTravelPlan) {
    return response.data.externalServices.getTravelPlan;
  }

  throw new SentryGraphQLError(
    'api.department.getDepartmentTravelPlan',
    response
  );
};

export default {
  getDepartment,
  getDepartmentWeather,
  getDepartmentTravelPlan,
};
